import { EChartsOption } from 'echarts';

export interface ChartOptionsHolder {
  chartOptions: EChartsOption | null;
}

export interface ForceChartOptionsRerenderOptions {
  clone?: boolean;
  cloneStrategy?: (options: EChartsOption) => EChartsOption;
}

/**
 * Temporarily clears and restores the chart options to force ngx-echarts to rebuild the instance.
 * Used when expanding/collapsing widgets alters the available space and the chart must resize.
 * @param target The object holding the chartOptions property to refresh.
 * @param options Optional settings for how to handle the existing options during the refresh.
 */
export function forceChartOptionsRerender(
  target: ChartOptionsHolder,
  options?: ForceChartOptionsRerenderOptions
): void {
  if (!target.chartOptions) {
    return;
  }

  const shouldClone = options?.cloneStrategy != null || options?.clone === true;
  const currentOptions = shouldClone
    ? options?.cloneStrategy?.(target.chartOptions) ?? { ...(target.chartOptions as EChartsOption) }
    : target.chartOptions;

  target.chartOptions = null;

  setTimeout(() => {
    target.chartOptions = currentOptions;
  }, 0);
}
